import { getFedExOptIn } from '@shared/api/fedEx.js'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { computed } from 'vue'
import useVuexModule from '@shared/composables/vuexModule.js'

// TODO: Partial implementation (ENG-2846)
export const useClientStore = defineStore('client', () => {
  const vuex = useVuexModule('client', {
    defaults: {
      state: [
        'impersonator',
        'profilePic',
        ['firstName', ''],
        ['lastName', ''],
        ['isImpersonated', false],
        ['isAuthenticated', false],
        ['username', ''],
        ['email', ''],
        'authToken',
        ['membershipStatus', ''],
        'styleProfileId',
        ['returnCarrierPreference', 'FEDEX'],
        'shippingAddress',
        'pickupAddress',
        ['showFedexSuccessModal', false],
        ['membershipDetails', null]
      ],
      actions: [
        'getClient'
      ]
    }
  })

  const {
    impersonator,
    profilePic,
    firstName,
    lastName,
    showFedexSuccessModal,
    returnCarrierPreference
  } = vuex

  const name = computed(() => [firstName.value, lastName.value].filter(Boolean).join(' '))
  const greetingName = computed(() => firstName.value?.length > 0 ? firstName.value : 'Boss Lady')
  const hasProfileImage = computed(() => profilePic.value?.length > 0)
  const hasCustomProfileImage = computed(() => hasProfileImage.value && !profilePic.value.includes('dresses'))
  const impersonatorName = computed(() => [impersonator.value?.first_name, impersonator.value?.last_name].filter(Boolean).join(' '))
  const impersonatorGroups = computed(() => impersonator.value?.groups)
  const impersonatorIsStylist = computed(() => impersonatorGroups.value?.includes('Remote Stylist') ?? false)

  async function fedExOptIn () {
    await getFedExOptIn()
    returnCarrierPreference.value = 'FEDEX'
    showFedexSuccessModal.value = true
  }

  const formerMember = computed(() => vuex.membershipStatus.value === 'former_member')
  const latestSubscriptionPlanId = computed(() => vuex.membershipDetails.value?.latestSubscriptionPlanId)

  return {
    ...vuex,
    name,
    greetingName,
    hasProfileImage,
    hasCustomProfileImage,
    impersonatorName,
    impersonatorGroups,
    impersonatorIsStylist,
    fedExOptIn,
    formerMember,
    latestSubscriptionPlanId
  }
})

import.meta.hot?.accept(acceptHMRUpdate(useClientStore, import.meta.hot))
